import { getTOCLevels } from '@sigma-frontend-libs/commons'

export const className = 'documentation'

export const documentationLevels = {
  computed: {
    levels() {
      return getTOCLevels(this.locale)
    }
  }
}
